import {Routes, Route, Navigate, BrowserRouter, } from 'react-router-dom'; 
import Home from'./Pages/Home'   
import AboutUs from'./Pages/AboutUs'
import OurVision from'./Pages/OurVision'
import OurMotto from'./Pages/OurMotto'
import AdmissionEligibility from'./Pages/AdmissionEligibility'
import CMIEducationPolicy from'./Pages/CMIEducationPolicy'
import Curriculum from'./Pages/Curriculum'
import Facilities from'./Pages/Facilities'
import Management from'./Pages/Management'
import WhoWeAre from'./Pages/WhoWeAre' 
import ContactUs from'./Pages/ContactUs'
import ToppersX from'./Pages/ToppersX'
import ToppersXII from'./Pages/ToppersXII'
import SubGallery from'./Pages/SubGallery'
import CbseDisclosure from'./Pages/CbseDisclosure'
import Tc from'./Pages/Tc'
import VideoGallery from'./Pages/VideoGallery'
import Gallery from'./Pages/Gallery'
import Events from'./Pages/Events'
import ErpSoftware from'./Pages/ErpSoftware'
import News from'./Pages/News'
import PrincipalMessage from'./Pages/PrincipalMessage'
function App() { 
  return (
      <>
      <BrowserRouter>
       <Routes>
          <Route path="*" element={<Navigate to="/" />} /> 
          <Route path="/" element={<Home/>} />
          <Route path="/AboutUs" element={<AboutUs/>} /> 
          <Route path="/OurVision" element={<OurVision/>} /> 
          <Route path="/OurMotto" element={<OurMotto/>} /> 
          <Route path="/AdmissionEligibility" element={<AdmissionEligibility/>} />
          <Route path="/CMIEducationPolicy" element={<CMIEducationPolicy/>} />
          <Route path="/Curriculum" element={<Curriculum/>} />
          <Route path="/Facilities" element={<Facilities/>} />
          <Route path="/Management" element={<Management/>} />
           <Route path="/SubGallery" element={<SubGallery/>} />
          <Route path="/WhoWeAre" element={<WhoWeAre/>} /> 
          <Route path="/ContactUs" element={<ContactUs/>} /> 
          <Route path="/ToppersX" element={<ToppersX/>} /> 
          <Route path="/ToppersXII" element={<ToppersXII/>} /> 
           <Route path="/Tc" element={<Tc/>} /> 
           <Route path="/CbseDisclosure" element={<CbseDisclosure/>} /> 
          <Route path="/VideoGallery" element={<VideoGallery/>} /> 
          <Route path="/Gallery" element={<Gallery/>} /> 
          <Route path="/Events" element={<Events/>} /> 
           <Route path="/ErpSoftware" element={<ErpSoftware/>} /> 
           <Route path="/News" element={<News/>} /> 
           <Route path="/PrincipalMessage" element={<PrincipalMessage/>} /> 
       </Routes> 
     </BrowserRouter>
      </>
  )
}

export default App;
